import localForage from 'localforage';
import { persistReducer } from 'redux-persist';
import { type RootState } from 'app/store';
import { type MFAState, type MFAActionTypes } from 'app/store/types';

const initialState: MFAState = {};

const mfaReducer = (state = initialState, action: MFAActionTypes) => {
	switch (action.type) {
		case 'GET_LICENSE_GROUP_DATA_SUCCESS': {
			const {
				licenseGroupId,
				data: { mfa },
			} = action.payload;

			return {
				...state,
				[licenseGroupId]: {
					...state[licenseGroupId],
					...(mfa && { byId: mfa }),
				},
			};
		}
		case 'LOGGED_OUT_USER':
		case 'PURGE_STATE':
			return initialState;
		default: {
			return state;
		}
	}
};

export default persistReducer(
	{
		key: 'mfa',
		storage: localForage,
		whitelist: localStorage.getItem('persist') ? undefined : [],
	},
	mfaReducer,
);

// Selectors
export const getMFA = ({ app: { selectedLicenseGroupId }, mfa }: RootState) => mfa[selectedLicenseGroupId].byId;
